import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CircleComponent } from './circle.component';

@NgModule({
	declarations: [CircleComponent],
	imports: [CommonModule],
	exports: [CircleComponent],
})
export class CircleComponentModule {}
